import React from 'react';

export default ({ x, y, dir, w, conn }) => {
  const drawLine = (offs) => {
    let baseD = [
      `M ${x + w / 3 + (w / 2) * offs} ${y + w / 2} `,
      `l ${-w / 2} ${-w / 2}`,
      `l ${w / 2} ${-w / 2}`,
    ].join(' ');

    if (dir === 'u') {
      baseD = [
        `M ${x - w / 2} ${y - w / 3 + (w / 2) * offs} `,
        `l ${w / 2} ${-w / 2}`,
        `l ${w / 2} ${w / 2}`,
      ].join(' ');
    }

    if (dir === 'd') {
      baseD = [
        `M ${x - w / 2} ${y - w / 3 - (w / 2) * offs} `,
        `l ${w / 2} ${w / 2}`,
        `l ${w / 2} ${-w / 2}`,
      ].join(' ');
    }

    if (dir === 'r') {
      baseD = [
        `M ${x - w / 3 - (w / 2) * offs} ${y + w / 2} `,
        `l ${w / 2} ${-w / 2}`,
        `l ${-w / 2} ${-w / 2}`,
      ].join(' ');
    }

    return baseD;
  };

  const stroke = `#fff`;

  return (
    <>
      <path
        d={drawLine(-1)}
        className="dir-arrow"
        strokeWidth={1}
        stroke={stroke}
        strokeOpacity={1}
        fillOpacity={0}
        pointerEvents="none"
      />
      <path
        d={drawLine(0)}
        className="dir-arrow"
        strokeWidth={1}
        stroke={stroke}
        strokeOpacity={0.7}
        fillOpacity={0}
        pointerEvents="none"
      />
      <path
        d={drawLine(1)}
        className="dir-arrow"
        strokeWidth={1}
        stroke={stroke}
        strokeOpacity={0.4}
        fillOpacity={0}
        pointerEvents="none"
      />
    </>
  );
};
